export default __webpack_public_path__ + "8e02ddcea786cc8b50dbca3dc48985ef.ttf";